<template>
  <div>
    <v-divider></v-divider>
    <v-container>
      <v-row>
        <v-col cols="6" md="9" lg="7" xl="5" offset-lg="1" offset-xl="2">
          <h2 class="greend--text">Warenkorb</h2>
        </v-col>
        <v-col
          cols="6"
          md="3"
          align="right"
          v-if="$store.state.cart.length > 0"
        >
          <v-btn color="greend" small text @click="clearCart">
            Warenkorb leeren
          </v-btn>
        </v-col>
      </v-row>

      <v-row v-if="$store.state.cart.length == 0">
        <v-col cols="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
          <v-card outlined align="center" class="mb-10 pa-4">
            <v-card-text>
              Der Warenkorb ist leer.
            </v-card-text>
            <v-card-actions class="mb-4">
              <v-spacer />
              <v-btn small outlined color="greenb" to="shop">
                Zurück zum Online-Shop
              </v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-else>
        <v-col cols="12" sm="8" lg="7" offset-lg="1" xl="6" offset-xl="2">
          <ProductList />
        </v-col>
        <v-col cols="12" sm="4" lg="3" xl="2" order="first" order-sm="last">
          <div class="grey lighten-4 pb-2">
            <CheckoutBox />

            <div class="ma-4">
              <v-btn
                color="greend"
                dark
                @click="$router.push('shippingInfo')"
                block
                class="my-4"
              >
                zur Kasse
              </v-btn>
              <v-btn
                color="greend"
                outlined
                @click="$router.push('shop')"
                block
                class="my-4"
              >
                weiter einkaufen
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import ProductList from "../components/shop/ProductList";
import CheckoutBox from "../components/shop/CheckoutBox";
export default {
  components: {
    ProductList,
    CheckoutBox
  },
  methods: {
    clearCart() {
      if (
        confirm("Bitte bestätigen Sie, dass der Warenkorb geleert werden soll.")
      ) {
        this.$store.state.cart = [];
      }
    }
  },
  mounted() {
    this.$vuetify.goTo(0);
  }
};
</script>
